export default "__VITE_ASSET__CFonOlk3__"